/*
 * Copyright (C) 2023 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { buttonVariants } from '../button/button.component';
import { IconComponent } from '../icon/icon.component';
import { TooltipDirective } from '../tooltip/tooltip.directive';

@Component({
  selector: 'ods-back-button',
  imports: [RouterLink, TooltipDirective, IconComponent],
  template: `
    <a
      [routerLink]="linkTo"
      data-test-id="back-button"
      [class]="buttonVariants({ variant: 'ghost', size: 'fit' })"
      [tooltip]="tooltipText"
      tooltipAriaType="aria-label"
    >
      <ods-icon name="arrow-back" [config]="{ fill: 'text' }" />
    </a>
  `,
  host: { class: 'block w-fit' },
})
export class BackButtonComponent {
  @Input() tooltipText: string;
  @Input() linkTo: string | any[];

  readonly buttonVariants = buttonVariants;
}
